import { getBooleanFromValue } from '@/global/utils/utils'

export default {
  name: 'Cargo',

  computed: {
    cargoEditConfig () {
      return {
        title: this.$t('fleet/vehicle.cargo_space'),
        key: 'cargo',
        formData: this.formData?.item,
        onTabChange: () => {
          this.showMainEditButtons = true
        },
        editUpdate: (event) => {
          const { edit } = event || {}
          this.$set(this.disableTabs, 'canBus', edit)
          this.$set(this.disableTabs, 'readouts', edit)
          this.$set(this.disableTabs, 'documents', edit)
          this.$set(this.disableTabs, 'inspections', edit)
          this.$set(this.disableTabs, 'insurances', edit)
          this.$set(this.disableTabs, 'leasing', edit)
          this.$set(this.disableTabs, 'rangeLimits', edit)
          this.$set(this.disableTabs, 'serviceIntervals', edit)
          this.$set(this.disableTabs, 'serviceHistory', edit)
          this.$set(this.disableTabs, 'comments', edit)
          this.$set(this.disableTabs, 'damages', edit)
        },
        tabContent: [
          {
            title: this.$t('fleet/vehicle.cargo_space'),
            component: this.columnsContentComponent,
            rows: [
              {
                disabled: !getBooleanFromValue(this.permissions?.canEdit),
                columnsCount: 4,
                fields: [
                  {
                    key: 'cargo_space_pallets',
                    label: this.$t('fleet/vehicle.cargo_space_pallets'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'cargo_space_width',
                    label: this.$t('fleet/vehicle.cargo_space_width'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'cargo_space_length',
                    label: this.$t('fleet/vehicle.cargo_space_length'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'cargo_space_height',
                    label: this.$t('fleet/vehicle.cargo_space_height'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
